// extracted by mini-css-extract-plugin
module.exports = {"confirmationBlock":"Confirmation_confirmationBlock__39gkj"};